module.exports = {
	"typed_rules": {
		"title": "Rules v3",
		"menu": "Rules v3",
		"page_failed": "Rules could not be loaded. Unsaved changes are kept in this browser.",
		"load_failed": "Could not load the data.",
		"retry": "Retry",
		"find": "code, method, account, value…",
		"find_label": "Find",
		"disabled": "disabled",
		"off": "off",
		"close": "Close",
		"draft_restored": "Unsaved changes from your last visit were restored.",
		"draft_review": "Review",
		"read_only": "{type} is read-only for you: editing it needs {ability} or w_rules.",
		"legacy_engine": {
			"notice": "Rules are read-only here while the legacy engine serves. Until the switch, edit them in the Rules section.",
			"open": "Open Rules",
			"refused": "Not saved: the legacy engine still serves, so rules are edited in the Rules section until the switch."
		},
		"errors": {
			"validation": {
				"one": "Your unsaved changes have 1 error. Fix it, then try again:",
				"_": "Your unsaved changes have {count} errors. Fix them, then try again:"
			},
			"server": "The server failed (HTTP {status}). Try again in a moment.",
			"network": "The server didn't answer. Check your connection and try again."
		},
		"discard": {
			"title": "Discard changes?",
			"text": "Your edits in this form will be lost.",
			"confirm": "Discard",
			"all_title": "Discard all unsaved changes?",
			"all_text": "The edits in {names} haven't been saved and will be lost."
		},
		"view": {
			"rules": "Rules",
			"table": "Table",
			"pivot": "Pivot",
			"no_pivot": "None"
		},
		"table": {
			"add_cell": "Add a rule for {value}",
			"code": "Code",
			"any": "any",
			"variant": "{name} · {share}%",
			"action_by_type": {
				"routing": "Channels, in order",
				"availability": "Effect",
				"limits": "Limit",
				"payouts": "Payout setting",
				"display": "Setting",
				"banners": "Banner",
				"order": "Setting"
			}
		},
		"rule_set": {
			"title": "Rulesets",
			"new": "+ New ruleset",
			"none": "No {type} rulesets yet",
			"none_hint": "A ruleset groups rules that share a scope, such as one jurisdiction. Rules in it apply only once a change set with it is saved.",
			"scope": "Scope",
			"everyone": "everyone",
			"stack": "Stack",
			"only": "Only {conditions}",
			"settings": "Ruleset settings",
			"name": "Name",
			"name_placeholder": "e.g. RO · VIP",
			"enabled": "Enabled",
			"enabled_hint": "Enabled (a disabled ruleset is skipped with all its rules)",
			"scope_title": "Scope: every rule in this ruleset applies only when",
			"scope_empty": "No scope: the ruleset applies everywhere. Keep such a ruleset last.",
			"create": "Create ruleset",
			"new_of": "New {type} ruleset",
			"settings_of": "Ruleset settings · {name}",
			"delete": "Delete ruleset",
			"delete_title": "Delete ruleset “{name}”?",
			"delete_text": {
				"one": "Its 1 rule goes with it. Nothing is live until you save a change set.",
				"_": "Its {count} rules go with it. Nothing is live until you save a change set."
			},
			"rule_count": {
				"one": "1 rule",
				"_": "{count} rules"
			},
			"rule_count_matching": {
				"one": "{shown} of 1 rule",
				"_": "{shown} of {count} rules"
			},
			"last_change": "last change",
			"by": "by",
			"no_scope": "no scope: applies everywhere"
		},
		"rule": {
			"add": "+ Add rule",
			"edit_title": "Edit rule",
			"new_title": "New rule",
			"note_optional": "Note (optional)",
			"note_placeholder": "why it exists: a ticket link, an owner. A bare link shows as a link icon.",
			"applies_when": "Applies when",
			"scope_always": "Ruleset scope (always):",
			"everywhere": "everywhere",
			"then": "Then",
			"lifetime": "Lifetime",
			"lifetime_hint": "Leave empty for no end. Expired rules stop matching and show greyed out.",
			"add_to_rule_set": "Add to ruleset",
			"apply_hint": "Goes to the unsaved bar. Nothing is live until you save a change set.",
			"new_n": "New rule {n}",
			"new_mark": "new",
			"none_yet": "— none yet",
			"deleted": "deleted",
			"restore": "Restore",
			"none": "No rules match.",
			"empty": "No rules yet. Add one with “+ Add rule”.",
			"when": "When",
			"default": "default (no extra conditions)",
			"action": "Action",
			"enabled": "Enabled",
			"active_until": "Active until (UTC)",
			"note": "Note",
			"apply": "Apply",
			"edit": "Edit",
			"enable": "Enable",
			"disable": "Disable",
			"duplicate": "Duplicate",
			"delete": "Delete",
			"expired": "expired",
			"from_scope": "(scope)",
			"accounts": "Accounts",
			"usage": "usage",
			"imported_in": "Imported in #{id} ({date})",
			"imported": "Imported from the legacy rules",
			"history": "History of this rule",
			"open_history": "Open history",
			"not_saved": "Not saved yet.",
			"variant": "Variant {name} · {share}% of customers",
			"copy_link": "Copy link to this rule",
			"link_copied": "Link copied",
			"close": "Close",
			"pending_text": "…"
		},
		"date": {
			"previous": "Previous month",
			"next": "Next month",
			"weekdays": "Mo Tu We Th Fr Sa Su",
			"clear": "Clear"
		},
		"conditions": {
			"add": "+ Add condition…",
			"add_scope": "+ Add scope condition…",
			"remove": "Remove condition",
			"remove_value": "Remove",
			"type_value": "Type a value and press Enter",
			"any": "any",
			"yes": "yes",
			"no": "no",
			"pick": "Select…",
			"not_in_list": "{value} (not in list)",
			"range_0": "from",
			"range_1": "to",
			"between": "between",
			"and": "and",
			"utc_end_excluded": "UTC, end excluded",
			"time_backwards": "The end must come after the start.",
			"units": {
				"m": "minutes",
				"h": "hours",
				"d": "days"
			},
			"eu27": "+ EU 27",
			"emails_placeholder": "Paste one or more emails",
			"add_emails": "Add",
			"emails": "Emails: {count}. Separate several with commas, spaces or new lines; matching ignores case.",
			"skipped": "Skipped, not an email: {values}",
			"rule_hint": "Only conditions known when {type} rules run are offered.",
			"scope_hint": "Any context or customer condition can scope a ruleset. Method, processor and direction stay on the rules, where they become table columns."
		},
		"fields": {
			"add_variant": "+ Variant",
			"remove": "Remove",
			"add_channel": "+ Channel",
			"not_in": "{label} — not in {jurisdictions}",
			"pick_account": "Select an account…",
			"move": "Channel {position}: drag, or Alt+↑/↓ to move",
			"moved": "{name} moved to {position} of {count}",
			"remove_channel": "Remove channel",
			"channels_hint": "The first available channel opens the method; the rest are the cascade after a decline.",
			"one_order": "One order for everyone",
			"split": "Split customers (A/B)",
			"variant": "Variant {name}",
			"total": "total {total}%",
			"of_customers": "% of customers",
			"groups": "(customer groups {from}–{to})"
		},
		"actions": {
			"disable": {
				"explain": "The channel can't be paid: it leaves the cashier list and the cascade, and an order through it is rejected. No settings."
			},
			"hide_from_list": {
				"explain": "Only removes the channel from the cashier list. A request that names it directly still creates an order. No settings."
			},
			"preselect": {
				"explain": "Opens the cashier with this method selected. No settings."
			},
			"hide_from_logos": {
				"explain": "Leaves the method's logo out of the payment logos that project sites load (the logo row in a site's footer). The method itself stays in the cashier. No settings."
			},
			"block": {
				"label": "Reason shown to the customer",
				"hint": "Deposits only: withdrawals ignore blocks."
			},
			"deny": {
				"label": "Error returned when the order is created"
			},
			"limit_range": {
				"direction": "Direction",
				"currency": "Currency",
				"min": "Min",
				"max": "Max",
				"no_min": "no min",
				"no_max": "no max",
				"add": "+ Currency"
			},
			"period_cap": {
				"sum": "sum of payments",
				"per": "per",
				"systems": "Counted over methods",
				"any_system": "the matched method only",
				"processors": "and processors",
				"any_processor": "any processor"
			},
			"amount_step": {
				"label": "Amounts must be a multiple of"
			},
			"autopay_limit": {
				"none": "No limit (autopay uncapped)",
				"label": "Pay out automatically up to"
			},
			"payout_interval": {
				"label": "Pay out after",
				"minutes": "minutes"
			},
			"method_priority": {
				"label": "Priority",
				"hint": "Higher shows first."
			},
			"min_rating": {
				"label": "Minimum rating",
				"hint": "Channels rated below it are left out."
			},
			"icon": {
				"label": "Icon key",
				"placeholder": "e.g. card_rs"
			},
			"default_amount_strategy": {
				"label": "Default amount",
				"last_deposit": "The last deposit",
				"average": "The average deposit",
				"max_of_last_deposit_and_average": "The larger of the last and the average deposit"
			},
			"description_template": {
				"label": "Template",
				"hint": "Placeholders: {placeholders}"
			},
			"deposit_timeout": {
				"label": "Timeout"
			},
			"dashboard_comment": {
				"label": "Comment next to the channel in the Dashboard API"
			},
			"show_banner": {
				"code": "Banner code",
				"code_placeholder": "e.g. NOVABANKA_BANKING_HOURS",
				"places": "Places",
				"screen": "Screen, e.g. deposit",
				"any_system": "any system",
				"add_place": "+ Place",
				"texts": "Texts by locale",
				"no_texts": "No texts: the cashier uses the built-in text for the code.",
				"add_text": "+ Text…"
			},
			"customer_fee": {
				"fee": "Fee",
				"percentage": "%",
				"show": "Show to customer",
				"max": "Max fee (optional)"
			}
		},
		"checks": {
			"title": "Checks",
			"error": "error",
			"warning": "warning",
			"note": "note",
			"count_error": {
				"one": "1 error",
				"_": "{count} errors"
			},
			"count_warning": {
				"one": "1 warning",
				"_": "{count} warnings"
			},
			"count_note": {
				"one": "1 note",
				"_": "{count} notes"
			},
			"count_existing": {
				"one": "1 existing",
				"_": "{count} existing"
			},
			"elsewhere": {
				"one": "1 existing finding elsewhere (not blocking)",
				"_": "{count} existing findings elsewhere (not blocking)"
			},
			"all_clear": "All clear.",
			"move_above": "Move above {rule}",
			"existing": "(already saved like this; doesn't block)",
			"unavailable": "Checks are unavailable, so the changes can't be saved yet."
		},
		"save": {
			"count": {
				"one": "1 unsaved change",
				"_": "{count} unsaved changes"
			},
			"in": "in {names}",
			"deleted_name": "{name} (deleted)",
			"ruleset_order": "Ruleset order",
			"discard": "Discard",
			"save": "Save…",
			"checking": "Checking…",
			"title": {
				"one": "Save 1 change as one change set",
				"_": "Save {count} changes as one change set"
			},
			"confirm": "Save change set",
			"saving": "Saving…",
			"reason": "Why? One line, required. It goes into the history next to the change.",
			"reason_placeholder": "e.g. Move mb RO cards to the new CKO MID",
			"reason_short": "At least {min} characters, spaces aside.",
			"reason_required": "Say why in at least 3 characters.",
			"accept_warnings": "I've read the warnings",
			"conflict": "Someone saved these rulesets meanwhile. Their changes are below; your edits are kept on top of them. Review and save again.",
			"forbidden": "You can't save this: it needs {ability}.",
			"saved": "Saved as change set #{id}",
			"failed": "The change set was not saved.",
			"reload_failed": "Saved as change set #{id}, but the rules could not be reloaded.",
			"deleted": "(deleted since)"
		},
		"history": {
			"title": "History",
			"of": "History · {title}",
			"all_rule_sets": "All rulesets",
			"empty": "No changes yet.",
			"failed": "History could not be loaded.",
			"more": "Load more",
			"show_all": {
				"one": "Show the change",
				"_": "Show all {count} changes"
			},
			"show_fewer": "Show fewer",
			"reverted_in": "Reverted in",
			"kind": {
				"edit": "edit",
				"revert": "revert",
				"import": "import"
			},
			"filters": {
				"type": "Type",
				"rule_set": "Ruleset",
				"rule_code": "Rule code",
				"admin": "Admin",
				"account": "Account",
				"from": "From",
				"to": "To"
			}
		},
		"revert": {
			"action": "Revert this change",
			"reverting": "Reverting…",
			"title": "Revert change set #{id}",
			"restores": "Restores",
			"later": "Later change sets touched the same rules; the revert undoes them too.",
			"confirm_later": "Undo those changes too",
			"reason": "Your reason (required)",
			"preview_failed": "Could not load what the revert restores.",
			"failed": "The revert was not saved.",
			"done": "Reverted as change set #{id}"
		},
		"change_set": {
			"as_of": "As of change set #{id}",
			"changes": "Changes",
			"deleted": "deleted in this change",
			"created": "created in this change",
			"not_found": "This change set doesn't exist.",
			"failed": "The change set could not be loaded."
		},
		"check": {
			"title": "Check a payment",
			"customer_id": "Or a customer id",
			"live": "Live rules",
			"draft": "With your changes",
			"failed": "The check failed.",
			"invalid": "Not a valid {kind}.",
			"invalid_context": "{field} isn't a valid {kind}.",
			"skipped": "These draft rules have errors, so the check runs without them:",
			"unknown_facts": "Not known for this payment, so rules on them don't match: {facts}",
			"player": "▸ Player: {summary}",
			"player_open": "▾ Player",
			"reset": "Reset to the example",
			"player_empty": "nothing set, so the check takes the defaults every customer has",
			"no_channels": "No routing row matches: the method is not offered.",
			"unavailable": "{method} is not available for this payment: no channel is offered",
			"by": "by",
			"not_applying": "would apply if the method opened",
			"no_match": "no rule matched",
			"channels_for": "Channels for {method} ({direction}), in order",
			"from": "from",
			"variant": "variant {name} (customer group {group} is in {from}–{to})",
			"no_limit_rule": "No limit rule — the method's own limits apply",
			"default_limits": "No limit rule: the cashier's default {min} – {max} {currency} applies, the processor may narrow it",
			"no_min": "no min",
			"no_max": "no max"
		},
		"usage": {
			"title": "Account usage",
			"account": "Account",
			"rules": "Rules that use it",
			"no_rules": "No rule uses this account.",
			"history": "Rules history",
			"not_found": "This account doesn't exist.",
			"failed": "Usage could not be loaded."
		},
		"export": {
			"title": "Export",
			"title_csv": "Export rules as CSV",
			"this_tab": "This tab ({type})",
			"all_tabs": "All tabs",
			"only_matching": "Only rules matching “{query}”",
			"saved_only": "One row per rule, in the order the engine reads them: tab, ruleset, position, code, conditions, action and its value, note. It exports what is saved and live; unsaved changes are left out.",
			"download": "Download CSV",
			"exporting": "Exporting…"
		},
		"link": {
			"looking_up": "Looking up {code}…",
			"deleted": "{code} was deleted in change set #{id} by {admin}.",
			"not_found": "{code} couldn't be found."
		},
		"help": {
			"resolution": {
				"routing": "Each row sets the *channels* of its methods: accounts in order, of any processor, or a split into several orders. The *first matching row per method* wins. The first available channel opens the method; the rest are the cascade after a decline. A player's history can reorder the list: a channel that paid for them recently goes first, one that just failed goes last. Rulesets are checked in the order on the left.",
				"availability": "*Every matching rule applies.* When an order is created they are checked in this order, and the first that matches decides: *disable* (the channel can't be paid at all), then *block* (deposits only: the channel shows greyed with a reason and the order fails with it), then *deny* (the order fails with an error). *Hide* only takes the channel off the list. When several blocks match, the first one's reason is shown.",
				"limits": "*Method limits* (what the payment method supports): first matching row per direction and currency; period caps all apply; amount step: first match.\n*Market limits* (what we allow this customer): first matching row per direction and currency.\nThe effective limit is the *tighter of the two sections*; “Check a payment” shows both sections and the result for any payment.",
				"payouts": "The *first matching row* sets the autopay limit. A customer who matches no row has *no autopay cap*.",
				"display": "*First match per setting.*",
				"banners": "*Every matching rule applies*: all matching banners are shown, in ruleset and rule order. Banners are checked per player, not per payment method, so they show even when the page has no methods.",
				"order": "*First match per setting.*"
			},
			"order": {
				"routing": "For each method the first matching row wins, so a higher ruleset overrides lower ones only for the methods it has a matching row for.",
				"availability": "Every matching rule applies; order only picks which block reason is shown.",
				"limits": "Within each section the first matching row per direction and currency wins, so a higher ruleset overrides lower ones only where it has a row; then the tighter of the two sections applies. A rule applies only to the currencies it lists. A bound neither section sets falls back to the built-in 10 – 10 000 EUR.",
				"payouts": "The first matching row wins.",
				"display": "The first match wins per setting; lower rulesets fill in the settings higher ones don't set.",
				"banners": "Every matching rule applies; the order only sets the order banners are shown in.",
				"order": "The first match wins per setting; lower rulesets fill in the settings higher ones don't set."
			},
			"order_title": "How ruleset order works",
			"order_text": "A customer goes through every ruleset whose scope matches them, top to bottom. {hint} Drag ⠿ to reorder.",
			"stack_title": "Ruleset stack",
			"stack_text": "A customer in this ruleset's scope goes through every ruleset in the stack, in the list's top-to-bottom order (shown here left to right). {hint} A dashed ruleset applies only to some of these customers; hover it to see which.",
			"resolution_title": "How {type} rules resolve",
			"table_title": "How this table is built",
			"table_text": "*Columns* are the conditions this ruleset's rules use: add a rule with a new condition and a column appears. *Pivot* spreads a condition's values across the header; choose “None” for one row per rule. Click a cell to open its rule. “Rules” view lists the same rules one by one; drag them there to change priority.",
			"history_title": "How history works",
			"history_text": "Each save writes one change set with the reason and a before/after snapshot of every ruleset it touched. Revert writes a new change set; history is never rewritten. A change set's page shows exactly what was live after that save.",
			"check_title": "What this checks",
			"check_text": "Runs the saved rules the way the engine does: channels, availability, limits (method and market sections, and which one set the min and the max), display, order settings and payouts. Each answer names the rule that decided it and the rules that matched but lost. With unsaved edits it shows the live rules and your edited rules side by side. A bound no rule sets falls back to the built-in 10 – 10 000 EUR. Customer-period limits and the provider's own min/max still apply on top."
		}
	}
};